import { useState, useEffect } from 'react';
import { trackAffiliateClick } from '../../../utils/analytics';

export default function StickyFooterCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 500px
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 bg-[#DC2626] shadow-2xl transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-5">
        <div className="flex items-center justify-between gap-4">
          {/* Left Side - Message */}
          <div className="hidden md:block">
            <p className="text-white font-black text-lg">
              Don't let the next bully cost you $4,500
            </p>
            <p className="text-white/80 text-sm">
              Get your legal shield for $30/month
            </p>
          </div>

          {/* Right Side - CTA Button */}
          <a
            href="/#chooser"
            onClick={() => trackAffiliateClick('About Page Sticky CTA', '/#chooser', 'Story')}
            className="w-full md:w-auto bg-white hover:bg-gray-100 text-[#DC2626] font-black text-base md:text-lg px-8 py-4 rounded-lg transition-all duration-300 shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center gap-3"
          >
            <i className="ri-shield-fill text-2xl"></i>
            ACTIVATE MY SHIELD
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </div>
  );
}
